import React, { Component } from "react"
import Footer from "../footer/footer"
import HeaderNew from "../header/header"
import claim from '../assets/claim.png'


const works = [
    {
        "title": 'Contemporary Mosque Architecture: Modernization vs Identity & Spirituality',
        "author": "Karawia, Sherin",
        "affiliation": "Doha: Hamad Bin Khalifa University, M.A. Thesis, 2020",
        "body": "Over the years, CIS has taken the lead in organizing events such as conferences, roundtables, workshops, seminars, symposiums, and lectures of different magnitude which have been well recognized"
    },
    {
        "title": 'Contemporary Mosque Architecture: Modernization vs Identity & Spirituality',
        "author": "Karawia, Sherin",
        "affiliation": "Doha: Hamad Bin Khalifa University, M.A. Thesis, 2020",
        "body": "Over the years, CIS has taken the lead in organizing events such as conferences, roundtables, workshops, seminars, symposiums, and lectures of different magnitude which have been well recognized"
    },
    {
        "title": 'Contemporary Mosque Architecture: Modernization vs Identity & Spirituality',
        "author": "Karawia, Sherin",
        "affiliation": "Doha: Hamad Bin Khalifa University, M.A. Thesis, 2020",
        "body": "Over the years, CIS has taken the lead in organizing events such as conferences, roundtables, workshops, seminars, symposiums, and lectures of different magnitude which have been well recognized"
    },
    {
        "title": 'Contemporary Mosque Architecture: Modernization vs Identity & Spirituality',
        "author": "Karawia, Sherin",
        "affiliation": "Doha: Hamad Bin Khalifa University, M.A. Thesis, 2020",
        "body": "Over the years, CIS has taken the lead in organizing events such as conferences, roundtables, workshops, seminars, symposiums, and lectures of different magnitude which have been well recognized"
    }
]

class Claim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
        }
    }
    componentDidMount() {
        let i, name
        for (i = 0; i < works.length; i++) {
            name = "selected" + i
            this.setState({
                [i]: false
            })
        }
    }
    select(id) {
        if (this.state[id])
            this.setState({
                [id]: false
            })
        else
            this.setState({
                [id]: true
            })
    }
    render() {

        return (
            <div className="claimpage">
                <HeaderNew />
                <div className="listing">
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="heading">Sync your publications</h1>
                            </div>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className='container'>
                            <p className='select-text'>Select which publications to sync</p>
                            <div className="pubtoselect">
                                {works.map((data, index) => {
                                    let selected = "selected" + index
                                    return (
                                        <div className="single-pubs">
                                            <div className='rows'>
                                                <div className={this.state[index] ? "selected-box pointer" : "select-box pointer"} onClick={() => this.select(index)} >
                                                    {this.state[index] ? <img src={claim} className="claim-tick" /> : ""}
                                                </div>
                                                <div>
                                                    <div className='subheading'>{data.title}</div>
                                                    <p className="subdetail">{data.author}</p>
                                                    <p className="subdetail">{data.affiliation}</p>
                                                    <p className="body">{data.body}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className="button-row">
                                    <div className="sync-btn pointer">Sync</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Claim;